module.exports = "/_next/static/images/0e1f511fa9c7d6b6a8894b5bbc5bb909-background@2x.png";